import { createFileRoute, redirect } from "@tanstack/react-router";

// The login form lives at "/" (AuthGate); people still type /login.
export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
